
<template>
 <div>
    <v-btn color="blue-grey" rounded class="white--text font-weight-bold" @click="getPdf()"> <v-icon left>mdi-printer</v-icon> Imprimir</v-btn>
 </div>
</template>

<script>
import Api from '@/api/index';
import { mapState } from 'vuex';

export default {
  name: 'PrintOpenTransactions',
  props:{
    type_tabs:{
      type: Number,
      default: 0,
    }
  },
  computed:{
    model_type_tabs(){
      return "Driver"
    },
    ...mapState({
      oneDriver: state => state.Driver.oneDriver,
    }),
  },
  methods: {
    getFilter(){
      let filter = { 
        destinable_type: this.model_type_tabs,
        modality_id: this.activeModalityId,
        destinable_id: this.oneDriver.data.id
      }
      return filter
    },
    getPdf(){
      let id = this.$route.params.id
      let filter = this.getFilter()
      Api.Driver.getOpenPaymentsPdf(id, filter).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `motorista_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link.href)
      }).catch(error => {
        console.error({error})
      })

    },
  },
}
</script>